<path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2.4"
    d="M13.1847 29.0003c4.6637 0 8.4444-3.7807 8.4444-8.4444v-9.5742c1.2421.7185 2.6841 1.1297 4.2222 1.1297h1.4075V7.88921h-1.4075c-2.3318 0-4.2222-1.89035-4.2222-4.22222h-4.2222V20.5559c0 2.3319-1.8904 4.2222-4.2222 4.2222-2.3319 0-4.22224-1.8903-4.22224-4.2222s1.89034-4.2222 4.22224-4.2222v-4.2223c-4.66376 0-8.44447 3.7807-8.44447 8.4445 0 4.6637 3.78071 8.4444 8.44447 8.4444Z"
/>
